routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.cart', {
      url: __env.routes.cart,
      template: `<cart sh-ctrl="shCtrl"></cart>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/cart/cart.config.js